export default __webpack_public_path__ + "static/media/droplet.b2725dcf.svg";